import { Button } from '@cian/ui-kit';

import { FC, JSX } from 'react';

import { ChatButtonContainer } from './ChatButtonContainer';

export const ChatButtonWideCard: FC = () => {
  return (
    <ChatButtonContainer>
      {({ onClick }): JSX.Element => (
        <Button fullWidth size="XS" theme="fill_secondary" onClick={onClick}>
          Написать
        </Button>
      )}
    </ChatButtonContainer>
  );
};
